export default ({ request }) => ({

  teamRoster: ({ teamId }) =>
    request(`Team/Roster/${teamId}`),

  teamStatsSummary: ({ season, id, formula }) =>
    request(`Team/StatsSummary/${season}/${id}/${formula}`),

  teamNews: ({ id, pageSize = 30, pageNumber = 1 }) =>
    request(`Team/News/${id}/${pageSize}/${pageNumber}`),

  newsTags: () =>
    request(`News/Tags`),

  teamNewsFiltered: ({ id, pageSize = 30, pageNumber = 1, position = 'ALL', feed = '1' ,tag='ALL'}) =>
    request(`Team/News/${id}/${pageSize}/${pageNumber}/${position}/${feed}/${tag}`),

  teamNewsCustom: ({ id, pageSize = 30, pageNumber = 1, position = 'ALL', feed = '1', league = '0',tag='ALL' }) =>
    request(`Team/News/Custom/${id}/${pageSize}/${pageNumber}/${position}/${league}/${feed}/${tag}`),

  teamPlayerStatsBySeason: ({ id, formula }) =>
    request(`Team/PlayerStats/${id}/${formula}`),

  teamPlayerStatsByWeek: ({ season, id }) =>
    request(`Team/PlayerStatsByWeek/${season}/${id}`),

  teamDepthChart: ({ teamId }) =>
    request(`Team/DepthChart/0`),

  teamWeeklyStatsMappings: () =>
    request('Stats/ToolPositionStatMap/team-players-weekly-stats'),

  teamSeasonStatsColMappings: () =>
    request('Stats/ToolPositionStatMap/team-stats'),

});



// WEBPACK FOOTER //
// ./src/lib/api/teams.js